import styled from 'styled-components';

const StyledFlexbox = styled.div`
    display: flex;
    background-color: ${({ backgroundColour }) => backgroundColour};
    border: ${({ border }) => border};
    border-radius: ${({ borderRadius }) =>
        Array.isArray(borderRadius)
            ? `${borderRadius[0]}px ${borderRadius[1]}px ${borderRadius[2]}px ${borderRadius[3]}px`
            : `${borderRadius}px`};
    flex-direction: ${({ flexDirection }) => flexDirection};
    flex-wrap: ${({ flexWrap }) => flexWrap};
    gap: ${({ gap }) => (gap ? `${gap}px` : 0)};
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : 0)};
    overflow-y: ${({ overflowY }) => overflowY};
    overflow-x: ${({ overflowX }) => overflowX};
    padding: ${({ padding }) => `${padding}px`};
    place-content: ${({ placeContent }) => placeContent};
`;

export const Flexbox = ({
    children,
    backgroundColour = 'transparent',
    border = 'none',
    borderRadius = 0,
    flexDirection = 'row',
    flexWrap = 'wrap',
    gap = null,
    height = 'auto',
    marginTop = 0,
    overflowX = 'visible',
    overflowY = 'visible',
    padding = 0,
    placeContent = 'start',
    width = 'auto',
}) => {
    return (
        <StyledFlexbox
            backgroundColour={backgroundColour}
            border={border}
            borderRadius={borderRadius}
            flexDirection={flexDirection}
            flexWrap={flexWrap}
            gap={gap}
            height={height}
            marginTop={marginTop}
            overflowX={overflowX}
            overflowY={overflowY}
            padding={padding}
            placeContent={placeContent}
            width={width}
        >
            {children}
        </StyledFlexbox>
    );
};
